module.exports = __webpack_public_path__ + "0884f6a8af0e8d552de6b608c50ffc4e.png";